var map = {
	"./img_1.jpg": 22186,
	"./img_2.jpg": 61071,
	"./img_3.jpg": 3076,
	"./img_4.jpg": 99287,
	"./img_5.jpg": 61509,
	"./img_6.jpg": 92659,
	"./img_7.jpg": 94653,
	"./img_8.jpg": 20267,
	"./img_9.jpg": 10730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17671;